export default "__VITE_ASSET__lui75ZNq__"